'use es6';

export var ALL = 'all-products';
export var NONE = 'NONE';
export var EMAIL_TEMPLATES = 'EMAIL';
export var LANDING_PAGES = 'LANDING_PAGE';
export var SITE_PAGES = 'SITE_PAGE';
export var BLOG_TEMPLATES = 'BLOG';
export var PACKS = 'COS_TEMPLATE_PACK';
export var UNSUBSCRIBE_SIMPLE = 'UNSUBSCRIBE_SIMPLE';
export var ERROR_PAGE = 'ERROR_PAGE';
export var PASSWORD_PAGE = 'PASSWORD_PAGE';
export var SUBSCRIPTION_PREFERENCES = 'SUBSCRIPTION_PREFERENCES';
export var UNSUBSCRIBE_CONFIRMATION = 'UNSUBSCRIBE_CONFIRMATION';
export var CONTENT_SEARCH_RESULTS = 'CONTENT_SEARCH_RESULTS';
export var CUSTOM_MODULE = 'CUSTOM_MODULE';
export var CMS_THEME = 'CMS_THEME';